var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SetCountryView"},[_c('HeaderComponent',{directives:[{name:"show",rawName:"v-show",value:(_vm.header),expression:"header"}],staticClass:"fade-enter-active"}),_c('router-view',{staticClass:"slide-in-bottom",staticStyle:{"animation-duration":"1.5s"}}),_c('SetCountryComponent'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }